/* eslint-disable max-len */
export const messages = {
    validation: {
        firstNameEmpty: "Please enter your first name",
        lastNameEmpty: "Please enter your last name.",
        dealerNameEmpty: "Please enter a company name",
        passwordsNotEqual: "Passwords do not match",
        emailInvalid: "Invalid email address",
        urlInvalid: "Invalid url",
        invalidPIN: "Please enter a valid PIN using only numeric characters.",
        passwordInvalid:
            "Minimum of 1 Uppercase letter, 1 Lowercase letter, 1 Number and 1 Special character with length of minimum 8 characters.",
        agreeToTerms: "Please agree with the terms & conditions.",
        customerName: "Please enter a first and last name with at least 2 alpha-characters",
        maxLength: "Please enter no more than ${n} characters",
        minLength: "Please enter at least ${n} characters",
        exactLength: "Please enter ${n} characters",
        required: "Please enter a value",
        pattern: "Invalid character",
        humanName: "Please enter letters, numbers, period(.), hyphen(-), and apostrophe(') only with 2 characters minimum.",
        iccid: "Please enter up to 22 numbers",
        macAddress: "Invalid character",
        numberOnly: "Please enter numbers only",
        checksum: "Invalid input",
        trailingWhiteSpace: "Please do not end with trailing whitespace",
        alulaName: "This field requires alphabetical characters only, no digits or other characters with 2 characters minimum.",
        emailExisted: "This user has already been invited, check the mobile app user list below for the current status.",
        domainInvalid: "Valid Domain required.",
    },
    apiResponse: {
        serverError: "An error occurred. Please try again.",
        updatePasswordSuccess: "Password updated successfully.",
        updateEmailSuccess: "Email updated successfully.",
        updatePhotoUrlSucess: "Profile picture updated sucessfully",
        sendVerificationEmailSuccess: "Verification email sent.",
    },
};
